<template>
<div class="view">
  <decorate></decorate>
  <div class="main bank_page">
    <div class="nav">
      <div class="left">
        <router-link
          class="front icon_back"
          :to="{
            path: '/selfInfo/2',
            query: {
              uid: queryData.uid,
              userId: queryData.userId,
              appId: queryData.appId,
              TopHeight: queryData.TopHeight,
            },
          }"
        ></router-link>
      </div>
      修改提现信息
    </div>
    <div class="zfb">
      <van-field
        autosize
        readonly
        label="支付宝名称："
        placeholder="请输入支付宝姓名"
        v-model="alipayname"
      />
      <van-field
        autosize
        clearable
        label="支付宝账号："
        placeholder="请输入支付宝账号"
        v-model="number"
      />
    </div>
    <div class="submit" @click="getBank()">提交</div>
  </div>
  </div>
</template>
    <script>
import { mapState, mapMutations, mapActions, mapGetters } from "vuex";
import Vue from "vue";
import { Field, Area, Popup, Icon, Toast } from "vant";
import decorate from './element/decorate'
import "../css/aside.scss";
Vue.use(Field).use(Area).use(Popup).use(Icon);
export default {
  components: {decorate},
  data: function () {
    return {
      topHeight: 0,
      showLocat: false,
      number: "",
      alipayname: "",
    };
  },
  computed: {
    ...mapState(["homePage"]),
  },
  watch: {},
  created() {
    this.queryData = this.$route.query || {};
    this.topHeight = this.queryData.TopHeight;
    let obj = {
      alipayId: this.queryData.alipayId,
    };
    console.log(obj);
    this.$store.dispatch("homePage/fetchAlipayDetail", obj).then((res) => {
      this.number = res.number;
      this.alipayname = res.alipay_name;
    });
  },
  methods: {
    ...mapActions(["fetchHome"]),
    ...mapMutations([]),
    getBank() {
      let obj = {
        alipay_name: this.alipayname,
        number: this.number,
        alipayId: this.queryData.alipayId,
      };
      // console.log(obj)
      this.$store.dispatch("homePage/fetchEditAlipay", obj).then(() => {
        this.$dialog({
          title: "提醒",
          message: "修改提现成功",
        }).then(() => {
          this.$router.push({
            path: "/selfInfo",
            name: "selfInfo",
            query: this.queryData,
            params: { statusTab: 2 },
          });
        });
      });
    },
  },
  mounted() {
    // const self=this;
    // this.$refs.view.scroll.on('scroll',(position)=>{
    //     self.$parent.scrollY=position.y;
    // })
  },
};
</script>
    